import { useCallback } from 'react';

import { getCurrentUserInfo } from '../utils/auth';

import useWrappedApi from './useWrappedApi';

/**
 * Hook to fetch the current user's information with retry capability.
 * @returns Object containing user data, error state, loading state, and retry function.
 */
const useCurrentUserInfo = () => {
  const fetchUser = useCallback(() => getCurrentUserInfo(), []);
  const { isLoading, error, value, retry } = useWrappedApi(fetchUser);

  return {
    user: value,
    error,
    loading: isLoading,
    retry,
  };
};

export default useCurrentUserInfo;
